import { atom } from 'recoil';

export const hideNavState = atom<boolean>({
  key: 'hideNavState',
  default: false,
});
